// extracted by extract-css-chunks-webpack-plugin
module.exports = {"topic":"topic-lt4t-i4v clearfix","icon":"icon-1R4qMNeN"};